import { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { getRiskClassifications } from "../../../../services/consignado/risk-classification.service";

interface Props {
  onChange: (value: string | null) => void;
  value?: string | { value: string; label: string };
}

const RiskClassificationsSelect = ({ onChange, value }: Props) => {
  const [defaultOption, setDefaultOption] = useState<any>(null);

  // Carrega valor inicial (para edição)
  useEffect(() => {
    const loadInitialValue = async () => {
      if (typeof value === "string" && value) {
        try {
          const data = await getRiskClassifications({ page: 0, pageSize: 50 });
          const classification = data.find((el) => el.id === value);
          if (classification) {
            setDefaultOption({ value: classification.id, label: classification.name });
          }
        } catch (err) {
          console.error("Erro ao carregar valor inicial da classificação de risco:", err);
        }
      } else if (value && typeof value === "object") {
        setDefaultOption(value);
      }
    };

    loadInitialValue();
  }, [value]);

  const loadOptions = async ({ page }: any) => {
    const data = await getRiskClassifications({
      pageSize: 50,
      page: page || 0 * 20,
    });

    return {
      options: data.map((item: any) => ({
        value: item.id,
        label: item.name,
      })),
    };
  };

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      margin: "8px 0 0 0",
      backgroundColor: "white",
      borderColor: state.isFocused ? "#3182ce" : "#E2E8F0", 
      borderRadius: "0.35rem", 
      minHeight: "40px", 
      boxShadow: state.isFocused ? "0 0 0 1px #3182ce" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#3182ce" : "#cbd5e0",
      }
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
  };

  return (
    <div style={{ width: "100%" }}>
      <label>Classificação de risco</label>
      <AsyncPaginate
        menuPortalTarget={document.body} // Faz o menu flutuar sobre tudo
        menuPosition="fixed"
        styles={customStyles}
        value={defaultOption}
        loadOptions={loadOptions as any}
        onChange={(selected: any) => onChange(selected?.value || null)}
        additional={{ page: 0 }}
        debounceTimeout={400}
        isClearable
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
      />
    </div>
  );
};

export default RiskClassificationsSelect;
